const Promise = require('bluebird')
const Vue = require('vue')

module.exports = () => new Promise((resolve, reject) => {
    Vue.component('properties_outdated', {
        template: `
            <div class="grid-item col-xs-12 col-sm-6 col-md-6 col-lg-3">
                <div class="dashboard-widget-meus-imoveis">
                    <div class="display">
                        <div class="number">
                            <h3 class="font-blue-sharp">
                                <span data-counter="counterup" data-value="7800" v-if="data.info.count > 0">{{data.info.count}}</span>
                                <small class="font-blue-sharp" style="font-size:12px;">{{ data.info.count | plural "imovel desatualizado" "imóveis desatualizados" "Nenhum imóvel desatualizado" }}</small>
                            </h3>
                            <small>há {{data.info.outdated}} dias</small>
                        </div>
                        <div class="icon">
                            <i class="icon-pie-chart"></i>
                        </div>
                    </div>
                    <div class="col-lg-812 text-center" style="height:240px;" v-if="data.info.list.length < 1">
                        <img src="assets/imgs/img-ok.png" width="140px">
                        <h2>Parabéns</h2>
                        <h4>Você não possui imóveis desatualizados</h4>
                    </div>
                    <div v-if="data.info.list.length > 0">
                        <div class="progress">
                            <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: data.info.outdated_percentage + '%'}">
                                <span class="">
                                {{data.info.count}} Desatualizados</span>
                            </div>
                        </div>
                        <div class="">
                            <div v-slimscroll :height="200" :always="true">
                                <table class="table table-light table-condensed table-striped">
                                    <tbody>
                                        
                                        <tr v-for="item in data.info.list">
                                            <td>
                                                <span class="label label-default label-sm">{{item.updated_at | daysago}}</span>    
                                            </td>
                                            <td>{{item.typeInfo.name}}</td>
                                            <td class="visible-lg"><span>{{item.roomsCount.dorm}} <i class="fa fa-bed" style="font-size:12px;"></i></span></td>
                                            <td>
                                                <span v-if="item.for_sale">
                                                    {{item.sell_price | money}}
                                                </span>
                                                <span v-if="!item.for_sale && item.for_rent">
                                                    <span>{{item.rent_price | money}}</span> / mês
                                                </span>
                                                <span v-if="!item.for_sale && !item.for_rent">
                                                    -
                                                </span>
                                            </td>
                                            <td>
                                                <button class="btn btn-default btn-xs" v-property-info :id="item.id" :circling="ids"><i class="fa fa-eye"></i></button>
                                            </td>
                                        </tr>
    
                                    </tbody>
                                </table>
                            </div>	
                        </div>
                    </div>
                </div>

            </div>
        `,
        props: ['alias', 'data'],
        computed: {
            ids() {
                return this.data.info.list.map(i => i.id );
            }
        }
    })

    resolve()
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/widgets/properties_outdated.js